__turbopack_context__.v({
  "logo__image": "_upFNG_logo__image",
});
